import { ActionContext, ActionTree } from 'vuex';
import {
	SET_COMPANY_PROFILE_DATA,
	SET_ORG_KEY,
	SET_COMPANY_LOCATIONS,
	SET_MEMBERS_NETWORKS,
	SET_SOCIAL_MEDIA,
    SET_MEMBERS_NETWORK,
    SET_COMPANY_ACTIVITIES
} from './mutation-types';
import State from './state';
import RootState from '../../state'
import companyProfileService from '../../../services/companyProfileService'
import commonService from '../../../services/commonService'
import camelizer from '../../../../../../services/convertDataStrategies/classes/camelizer';
import { IAddEditLocationsOutput } from '../../../models/interfaces/iAddEditLocationOutput';
import { MemberNonprofits } from '../../../models/classes/companyProfile/memberNonprofits';
import { SupportedNonprofits } from '../../../models/classes/companyProfile/supprotedNonprofits';
import { IAddEditSocialMediaOutput } from "../../../models/interfaces/iAddEditSocialMediaOutput";
import { ISearchMembersInCompanyOutput } from "../../../models/interfaces/companyProfile/iSearchMembersInCompanyOutput";
import { IMembersInput } from "../../../models/interfaces/companyProfile/iMembersInput";
import { IMembersInCompany } from "../../../models/interfaces/companyProfile/iMembersInCompany";
import { IMemberDataPortion } from "../../../models/interfaces/companyProfile/iMemberDataPotion";
import { ICompanyActivitiesOutput } from "../../../models/interfaces/companyProfile/iCompanyActivitiesOutput";

// ActionTree<[current state], [root state]>
const actions: ActionTree<State, RootState> = {
    async getCompanyProfileData({ commit, state }: ActionContext<State, RootState>, key: string): Promise<any> {
        const { data } = await companyProfileService.getCompanyProfileData(key);
        const commitData = await commit(SET_COMPANY_PROFILE_DATA, camelizer.convert(data.company));

        return commitData;
	},

	setCompanyLocations({ commit, state }: ActionContext<State, RootState>, data: IAddEditLocationsOutput) {
		return new Promise((resolve, reject) => {
			commonService.changeOrganizationLocations(data).then((rsp: any) => {
				const locations = camelizer.convert(rsp.data.locations);

				commit(SET_COMPANY_LOCATIONS, locations);
				resolve(rsp.data);
			});
		});
	},

	setOrgKey({ commit }: ActionContext<State, RootState>, orgKey: string) {
		return new Promise((resolve, reject) => commit(SET_ORG_KEY, orgKey));
	},

	changeCompanyProfile({ commit, dispatch, }: ActionContext<State, RootState>, orgKey: string) {
		return new Promise((resolve, reject) => {
			dispatch('setOrgKey', orgKey);
			resolve(dispatch('getCompanyProfileData', orgKey));
		});
	},

	getSupportedNonprofits({ commit }: ActionContext<State, RootState>, data: any) {
		return new Promise((resolve, reject) => {
			companyProfileService.getSupportedNonprofits(data).then((rsp: any) => {
				const camelizedData = new SupportedNonprofits(camelizer.convert(rsp.data) as SupportedNonprofits);

				resolve(camelizedData);
			});
		});
	},

	getMemberNonprofits({ commit, }: ActionContext<State, RootState>, data: any) {
		return new Promise((resolve, reject) => {
			companyProfileService.getMemberNonprofits(data).then((rsp: any) => {
				const camelizedData = new MemberNonprofits(camelizer.convert(rsp.data) as MemberNonprofits);

				resolve(camelizedData);
			});
		});
	},

	setMembersNetworks({ commit, }: ActionContext<State, RootState>, data: IMembersInput) {
		commit(SET_MEMBERS_NETWORKS, data)
	},

	setMembersNetwork({ commit, }: ActionContext<State, RootState>, membersData: IMemberDataPortion) {
		commit(SET_MEMBERS_NETWORK, membersData)
	},

	addEditSocialMedia({ commit }: ActionContext<State, RootState>, socialMediaData: IAddEditSocialMediaOutput): Promise<any> {
		return new Promise((resolve, reject) => {
			commonService.changeOrganizationSocialMedia(socialMediaData)
				.then((res: any) => {
					const socialMedia = socialMediaData.socialMedia.map((el: any) => {
						el.imgUrl = '';

						return el;
					});

					commit(SET_SOCIAL_MEDIA, socialMedia);
					resolve(res);
				})
				.catch((error: any) => reject(error));
		});
	},

	async getMembersInCompany({ commit }: ActionContext<State, RootState>, searchData: ISearchMembersInCompanyOutput): Promise<any> {
		const { data } = await companyProfileService.searchMembersInCompany(searchData);
		const result = camelizer.convert(data);

		return result;
	},

    async getCompanyActivities({ commit }: ActionContext<State, RootState>, searchData: ICompanyActivitiesOutput): Promise<any> {
        const { data } = await companyProfileService.getCompanyActivities(searchData);
        const result = camelizer.convert(data);

        commit(SET_COMPANY_ACTIVITIES, result);

        return result;
    },

};

export default actions;


// WEBPACK FOOTER //
// ./static-content/private/javascripts/store/modules/company/actions.ts